import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/tooltip";
import { cn } from "lib/utils";

const PeerSimilarityBadge = ({ similarity, keywords = [] }) => {
  // Determine color based on similarity score
  let barColor = "#10b981"; // emerald-500
  if (similarity < 70) {
    barColor = "#f59e0b"; // amber-500
  } else if (similarity < 85) {
    barColor = "#0f3460"; // explore
  }

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-2.5 w-[90px] cursor-help shrink-0 group">
            <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
              <div 
                className="h-full rounded-full transition-all duration-500 ease-out group-hover:brightness-110"
                style={{ width: `${similarity}%`, backgroundColor: barColor }}
              />
            </div>
            <span className="text-[13px] font-medium tabular-nums text-slate-700 w-9 text-right group-hover:text-slate-900 transition-colors">
              {similarity}%
            </span>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="w-64 p-3 bg-slate-800 border-slate-700">
          <div className="space-y-2">
            <p className="text-sm font-semibold text-white flex items-center justify-between">
              Similarity Score
              <span className="text-blue-400">{similarity}%</span>
            </p>
            <p className="text-xs text-slate-300">
              Based on overlapping research topics, citation patterns, and entity characteristics.
            </p>
            {keywords && keywords.length > 0 && (
              <div className="pt-2 border-t border-slate-600">
                <span className="text-[10px] uppercase tracking-wider text-slate-400 font-medium block mb-1">
                  Top Matched Keywords
                </span>
                <div className="flex flex-wrap gap-1">
                  {keywords.map((kw, i) => (
                    <span key={i} className="inline-flex rounded-sm bg-slate-700 px-1.5 py-0.5 text-[10px] text-slate-200">
                      {kw}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default PeerSimilarityBadge;
